import { render, staticRenderFns } from "./merchantProduct.vue?vue&type=template&id=4d9f2c5e&scoped=true&"
import script from "./merchantProduct.vue?vue&type=script&lang=ts&"
export * from "./merchantProduct.vue?vue&type=script&lang=ts&"
import style0 from "./merchantProduct.vue?vue&type=style&index=0&id=4d9f2c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f2c5e",
  null
  
)

export default component.exports